import React, { useEffect, useRef, useState } from "react";
import { match } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import MUIDataTable, {
  MUIDataTableColumnDef,
  MUIDataTableOptions,
} from "mui-datatables";
import IRouterComponentProps from "../../../models/IRouterComponentProps";
import AuthService from "../../auth/AuthService";
import {
  productTextSearch,
  auctionTendorProductUrl,
  tendorBidUrl,
  getBidInfo,
  getAuctionEndTimeUrl,
  productUrl,
  getMyLatestBidsForUser,
} from "../../../common/config/app.endpoints";
import AppLayout from "../../layouts/AppLayout";
import Alert from "../../../common/elements/Alert";
import LoadingSpinner from "../../../common/elements/LoadingSpinner";
import ApiTimeout from "../../../modules/ApiTimeout";
import { oAuth } from "../../../routes/basic/BasicAppRouter";
import {
  StyledButton,
  StyledModal,
} from "../../../common/materials/GenericStyleComponent";
import BlockUserModal from "../BlockUser/BlockUserModal";
import { MuiThemeProvider } from "@material-ui/core/styles";
import update from "immutability-helper";
import TabLayout from "./TabLayout";
import TenderTabLayout from "./TendorTabLayout";
import ProductFilter from "./ProductsFilter";
import ParcelItemFilter from "./ParcelFilter";
import Countdown from "react-countdown";
import moment from "moment";
import TendorMybids from "./TendorMybids";
import {
  StyledActionBarContainer,
  StyledBoxContent,
  StyledBtnContainer,
  StyledButtonGray,
  StyledButtonHeader,
  StyledContainer,
  StyledContent,
  StyledCoreDataGridContainer,
  StyledDropDown,
  StyledLayoutGrid,
  StyledLayoutGridMain,
  StyledName,
  StyledTabLayout,
  StyledTextWrapper,
  StyledTimeGridContainer,
  StyledTimer,
} from "../../../common/materials/GenericStyleMuitable";
import ViewEndedModal from "../auction/ViewEndedModal";
import {
  getAbbreviation,
  makeLinkClickable,
  openCertificateLinkPopup,
} from "../../../common/GenericFunctions";
import EllipsisText from "../../../common/elements/EllipsisText";

import {
  convertedValue,
  exportExcel,
  getDescription,
  getMyLatestStoredBids,
  getRapNet,
  getReturnMyLatestStoredBid,
} from "./TenderGenericFunc";
import TenderSlider from "./bidPopupComponent/TenderSlider";
import {
  createTheme,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { StyledButtonView, Styledview } from "./TendorPreviewView";
import CoreDataGridOfTenderNew from "./tenderMobileComponets/CoreDataGridOfTenderNew";
import TenderListOfProduct from "./tenderMobileComponets/TenderListOfProduct";
import copy from "copy-to-clipboard";
import {
  faEdit,
  faHeart,
  faShareSquare,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ViewTenderExtendedModal from "../auction/ViewTenderExtendedModal";
import BulkBidPopup from "./bidPopupComponent/BulkBidPopup";
import styled from "styled-components";
import PubSub from "pubsub-js";
import AlertReadOnlyUser from "../../../common/elements/AlertReadOnlyUser";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import TenderCommanPagination from "../../core-grid/grid-actions/TenderCommanPagination";
import { AppDispatch } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  resetCurrentApiStartCount,
  reSetIsMybids,
  resetItemPerPage,
  reSetJwlIsMybids,
  selectcurrentApiStartCount,
  selectItemPerPage,
  setCurrentApiStartCount,
  setItemPerPage,
} from "../../../redux/slice/commanPagination/commanPaginationSlice";
import { RootState } from "../../../redux/reducer";
import {
  resetTenderDiamondAllProductSelectAll,
  resetTenderDiamondGridProductAllProductIndexes,
  resetTenderIsGridView,
  selectTenderGridView,
  setTenderDiamondAllProductSelectAll,
  setTenderDiamondGridProductAllProductIndexes,
  setTenderIsGridView,
} from "../../../redux/slice/annual/commanAnnualSlice";
import { StyledSelectAllButtonHeader } from "../../365Auction/component/DiamondProductStyle";
import { biddingProductDetails } from "../../../redux/slice/commonProduct/commonProductDetailsSlice";
import BasicSearchBox from "../../core-grid/grid-actions/BasicSearchBox";

const faEditProps = faEdit as IconProp;
const faHeartProps = faHeart as IconProp;
const faShareSquareProps = faShareSquare as IconProp;

export const StyledHeaderContainer = styled(Grid)`
  padding-top: 10px;
`;
export const StyledHederGrid = styled(Grid)``;

interface DetailParams {
  auctionId: string;
  auctionUserId: string;
  auctionDate: string;
  auctionName: string;
}

export interface IProductViewProps extends IRouterComponentProps {
  match: match<DetailParams>;
  t?: any;
  location: any;
}

let body: any = [];
let totalElement: number = 0;
let page: number = 0;

let payload: any = {};
let startCount: number = 0;
let endCount: number = 10;
let rowSelectedData: any;

let SelectedTableData: any;
let updatedRowData: any;
let updateRowIndex: any;
let auctionProductResult: any;

let seconds: any = "";

let filter: any = [];
let filteredValues: any = "";
let filteredParcelValues: any = "";
let auctionName: string = "";
let details: any;
let length: any;
let auctionDate: any;
let timeLeftLableColor: boolean;

const columnIndexes = {
  serialNo: 0,
  productId: 1,
  auctionUserId: 2,
  productCode: 4,
  lab: 5,
  certificate: 6,
  description: 7,
  productDescription: 8,
  carat: 9,
  color: 10,
  clarity: 11,
  remarks: 12,
  noOfPieces: 13,
  shape: 14,
  sieve: 15,
  cutGrade: 16,
  polish: 17,
  symmetryAbbreviation: 18,
  flour: 19,
  currency: 20,
  peicePerCt: 21,
  myLatestBids: 22,
  notes: 23,
  currentBidPrice: 24,
  repnetPrice: 25,
  noOfBids: 26,
  rowColor: 27,
  exchangeRate: 28,
  parcelType: 29,
  noOfBidders: 30,
  currentBidValue: 31,
  hieghestBidValue: 32,
  watched: 31,
  sellerAuctionUserId: 32,
  rapnetPercentage: 33,
  previousHighestBidder: 35,
  holdPreviousBidder: 36,
  shapeAbbreviation: 37,
  polishAbbreviation: 38,
  flourAbbreviation: 39,
  colorValue: 40,
};

let date: string | string[] = "";
let indexsForBulkBidItems: any = [];
let myLatestBidForProduct: any = [];
let isReadOnlyUser: any;
let isAuctionUserId: boolean;
const initialState = {
  mouseX: null,
  mouseY: null,
};

//single product redirect
let redirectProduct: any = [];

const TendorAuctionView = (props: IProductViewProps) => {
  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MUIDataTableSelectCell: {
          fixedHeader: {
            background: "white",
          },
          fixedLeft: {
            background: "white",
          },
        },
      },
    });

  const [auctionProducts, setAuctionProducts] = useState([]);
  const [openToast, setOpenToast] = useState(false);
  const [showAlertMessage, setShowAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [alertType, setAlertType] = useState("");
  const [isShowSearchBox, setShowSearchBox] = useState(true);
  const [apiTimeout, setApiTimeout] = useState(false);
  const [onAction, setOnAction] = useState(false);
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const [userBlock, setUserBlock] = useState(false);
  const [textSearchArray, setTextSearchArray] = useState([]);
  const [optionValue, setOptionValue] = useState("");
  const [isShowParcelItem, setShowParcelItem] = useState(false);
  const [openEndedModal, setOpenEndedModal] = useState(false);
  const [openTenderExtended, setOpenTenderExtended] = useState(false);
  const [showTenderSlider, setshowTenderSlider] = useState(false);
  const [singleBiddingPopup, setSingleBiddingPopup] = useState(false);
  const [showBulkBidPopup, setShowBulkBidPopup] = useState(false);
  const [showBulkBidButton, setShowBulkBidButton] = useState(false);
  const [isDataRefresh, setIsDataRefresh] = useState(false);
  const theme = useTheme();
  const [isUserClosedExtendedPopup, setIsUserClosedExtendedPopup] =
    useState(false);
  const notSmallDevices = useMediaQuery(theme.breakpoints.between("md", "xl"));
  const [shouldGetAllData, setShouldGetAllData] = useState(false);
  const [isDataTableRefresh, setIsDataTableRefresh] = useState(false);
  const [isTopElementHide, setIsTopElementHide] = useState(false);
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [openReadOnlyUserToast, setOpenReadOnlyUserToast] = useState(false);
  const [isTableExpanded, setIsTableExpanded] = useState(false);
  const [currentProductId, setCurrentProductId] = useState<string>("");
  const [isSelected, setIsSelected] = useState<boolean>(false);
  const [mouseState, setMouseState] = React.useState<{
    mouseX: null | number;
    mouseY: null | number;
  }>(initialState);
  let isAuctionPage: any = true;
  let isCategoryPageType: any = true;

  const [tabValue, setTabValue] = useState({
    allProducts: true,
    myBids: false,
  });

  const Auth = new AuthService();
  const { t } = props;
  // let eventSource: any = undefined;
  const eventSource: any = useRef<any>();
  const maxRetryCount = 2;
  const countRef = useRef(0);
  const itemsPerPageUseRef = useRef(10);
  const selectPageUseRef = useRef(0);
  const dispatch: AppDispatch = useDispatch();

  const isGridView: any = useSelector((state: RootState) =>
    selectTenderGridView(state)
  );

  useEffect(() => {
    getAuctionEndTime(props.match.params.auctionId);
    dispatch(resetTenderDiamondGridProductAllProductIndexes());
    dispatch(resetTenderDiamondAllProductSelectAll());
    isReadOnlyUser = localStorage.getItem("isReadOnlyUser");
    isReadOnlyUser = JSON.parse(isReadOnlyUser);
    localStorage.removeItem("currentPageOfPreview");
    localStorage.removeItem("jwlauctionUserId");
    localStorage.removeItem("userId");
    //data table api calling
    getAllUpdatedData();
    getMyLatestBids(props.match.params.auctionId);
    //note: we are removing activePageNumber from localstorage since we already loaded that page in "getTendorAucProducts()"
    localStorage.removeItem("activePageNumber");
    dispatch(reSetJwlIsMybids());

    setTimeout(() => {
      setIsDataRefresh(!isDataRefresh);
    }, 3000);

    return () => {
      if (eventSource.current !== undefined || eventSource.current !== null) {
        if (eventSource.current.close !== undefined) {
          eventSource.current.close();
        }
      }
      auctionName = "";
    };
  }, []);

  //redux page selector
  const selectcurrentApiStartCountValue: any = useSelector((state: RootState) =>
    selectcurrentApiStartCount(state)
  );

  const selectItemPerPageValue: any = useSelector((state: RootState) =>
    selectItemPerPage(state)
  );

  useEffect(() => {
    localStorage.setItem(
      "apiStartCount",
      JSON.stringify(selectcurrentApiStartCountValue * selectItemPerPageValue)
    );
    getTendorAucProducts(
      props.match.params.auctionId,
      selectcurrentApiStartCountValue
    );
  }, [selectItemPerPageValue, selectcurrentApiStartCountValue]);

  useEffect(() => {
    if (shouldGetAllData) {
      getAllUpdatedData();
      setShouldGetAllData(false);
    }
  }, [shouldGetAllData]);

  //get All updated data
  const getAllUpdatedData = () => {
    if (countRef.current < maxRetryCount) {
      eventSource.current = new EventSource(getBidInfo);
      eventSource.current.onmessage = (event: any) => {
        updatedRowData = JSON.parse(event.data);
        if (updatedRowData !== undefined) {
          if (updatedRowData.alive) {
            //This will listen only for events
          } else {
            if (props.match.params.auctionId === updatedRowData.auctionId) {
              updateRowIndex = auctionProductResult.findIndex(
                (product: any) => product.perId === updatedRowData.perId
              );
              const mapping: any = {};
              if (
                auctionProductResult !== undefined &&
                auctionProductResult.length > 0
              ) {
                auctionProductResult.map((items: any) => {
                  mapping[items.perId] = {
                    watched: items.watched,
                  };
                  return true;
                });
              }
              var updatedArr: any = [];
              if (updateRowIndex !== -1) {
                updatedArr = update(auctionProductResult, {
                  $splice: [[updateRowIndex, 1, updatedRowData]],
                });
              }
              const arr = [...updatedArr];
              arr.map((items: any) => {
                if (mapping[items.perId] !== undefined) {
                  items.watched = mapping[items.perId].watched;
                }
                return true;
              });

              auctionProductResult = arr;
              console.log(auctionProducts);
              if (updateRowIndex !== -1) {
                setAuctionProducts(auctionProductResult);
              }
              setShouldGetAllData(false);
            }
          }
        }
      };
      eventSource.current.onerror = (err: any) => {
        console.error("EventSource failed:", err);
        countRef.current = countRef.current + 1;
        setShouldGetAllData(true);
      };
    }
  };

  const getAuctionEndTime = (auctionId: string, callBack?: any) => {
    if (!oAuth()) {
      props.history.push("/");
    } else {
      Auth.getRequest(
        `${getAuctionEndTimeUrl}/${auctionId}/end_time`,
        async (status: number, response: any) => {
          if (status === 200) {
            await getLeftTime(response.endDate);
            setIsLoading(false);
            timeLeftLableColor = response.tenderExtended;
            if (response.state === "Ended") {
              setOpenEndedModal(true);
            }
            if (callBack !== undefined) {
              callBack(response);
            }
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response[0].message);
            setAlertType("error");
            setOpenToast(true);
          }
        }
      );
    }
  };

  //Note: Get my All LatestBid using this Api
  const getMyLatestBids = (auctionId: string) => {
    if (!oAuth()) {
      props.history.push("/");
    } else {
      Auth.getRequest(
        `${getMyLatestBidsForUser}?auctionId=${auctionId}`,
        (status: number, response: any) => {
          if (status === 200) {
            setIsLoading(false);
            myLatestBidForProduct = response;
            setTimeout(() => {
              setIsDataTableRefresh(!isDataTableRefresh);
            }, 2000);
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage("Internal Server Error");
            setAlertType("error");
            setOpenToast(false);
          }
        }
      );
    }
  };

  const handleBidClick = (tableData: any) => {
    rowSelectedData = tableData.rowData;
    SelectedTableData = tableData.tableData;
    getProductsDetails(SelectedTableData);
    details = tableData.rowIndex;
    // setButtonIndex(rowSelectedData[columnIndexes.serialNo]);
    setshowTenderSlider(true);
  };

  //rediract from bid now button of product details page -------
  const renderAutomaticBidPopup = (data: any) => {
    const rediractProductId: any = localStorage.getItem(
      "currentProductIdOfBidNow"
    );
    rowSelectedData = [];
    if (rediractProductId !== null) {
      const indexOfProduct = auctionProducts.findIndex(
        (item: any) => item.perId === rediractProductId
      );
      rowSelectedData = data.rowData;
      SelectedTableData = data.tableData;
      details = indexOfProduct;
      length = auctionProducts.length;

      if (details !== -1) {
        setshowTenderSlider(true);
      } else {
        redirectProduct.push(biddingProductDetails);
        console.log(redirectProduct);
        if (biddingProductDetails !== undefined) {
          const indexOfProduct = redirectProduct.findIndex(
            (item: any) => item.perId === rediractProductId
          );
          rowSelectedData = biddingProductDetails;
          SelectedTableData = redirectProduct;
          details = indexOfProduct;
          length = redirectProduct.length;
          setSingleBiddingPopup(true);
        }
      }
    }
    localStorage.removeItem("currentProductIdOfBidNow");
  };

  const renderAutomaticBidPopupInMobile = (data: any) => {
    const rediractProductId: any = localStorage.getItem(
      "currentProductIdOfBidNow"
    );
    if (rediractProductId !== null) {
      const indexOfProduct = auctionProducts.findIndex(
        (item: any) => item.perId === rediractProductId
      );
      rowSelectedData = data;
      SelectedTableData = auctionProducts;
      details = indexOfProduct;
      length = auctionProducts.length;
      // setButtonIndex(data.serialNo);
      if (details !== -1) {
        setshowTenderSlider(true);
      } else {
        redirectProduct.push(biddingProductDetails);
        if (biddingProductDetails !== undefined) {
          const indexOfProduct = redirectProduct.findIndex(
            (item: any) => item.perId === rediractProductId
          );
          rowSelectedData = biddingProductDetails;
          SelectedTableData = redirectProduct;
          details = indexOfProduct;
          length = redirectProduct.length;
          setSingleBiddingPopup(true);
        }
      }
      setTimeout(() => {
        localStorage.removeItem("currentProductIdOfBidNow");
      }, 3000);
    }
  };

  // Get index for tender bid popup
  const getProductsDetails = (productsDetails: any) => {
    length = auctionProducts.length;
    productsDetails.map((items: any, index: any) => {
      if (items.perId === rowSelectedData[columnIndexes.productId]) {
        details = index;
      }
      return true;
    });
    return details;
  };

  //index of Mobile ui component
  const getBoxIndex = (boxIndex: any) => {
    length = auctionProducts.length;
    details = boxIndex;
    setshowTenderSlider(true);
  };

  // Tender bulk bid popup
  const bulkBidPopupHandler = () => {
    setShowBulkBidPopup(true);
  };

  const handleBtnValue = (
    values: number,
    currentBidPrice: any,
    productId: any,
    myBidValues: any
  ) => {
    var data = [
      {
        bidIncreasedBy: values,
        bidPrice: currentBidPrice,
        auctionUserId: props.match.params.auctionUserId,
        auctionId: props.match.params.auctionId,
        productId: productId,
      },
    ];
    let updateRowIndex = myLatestBidForProduct.findIndex(
      (product: any) => product.productId === myBidValues.productId
    );
    if (updateRowIndex === -1) {
      var myLatestBidForProductObjectData: any = [
        ...myLatestBidForProduct,
        myBidValues,
      ];
      myLatestBidForProduct = myLatestBidForProductObjectData;
    } else {
      var updatedArray = update(myLatestBidForProduct, {
        $splice: [[updateRowIndex, 1, myBidValues]],
      });
      myLatestBidForProduct = updatedArray;
    }
    bidProduct(data);
  };

  const bulkBidHandler = (values: any[], myBidBulkValues: any) => {
    myLatestBidForProduct = myBidBulkValues;
    bidProduct(values);
    onGridSelectionChange(0);
    PubSub.publish("resetGridBoxIndex", []);
    dispatch(resetTenderDiamondGridProductAllProductIndexes());
    dispatch(resetTenderDiamondAllProductSelectAll());
    setIsSelected(false);
  };

  const bidProduct = (payloadBid: any) => {
    if (!oAuth()) {
      props.history.push("/");
    } else {
      Auth.postRequest(
        tendorBidUrl,
        payloadBid,
        (status: any, response: any) => {
          if (status === 200) {
            setIsDataRefresh(!isDataRefresh);
            getMyLatestBids(props.match.params.auctionId);
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setOnAction(false);
          } else if (status === 404) {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(`${t("common:invalidRequest")}`);
            setAlertType("error");
            setOpenToast(true);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response[0].message);
            setAlertType("error");
            setOpenToast(true);
          }
        }
      );
    }
  };

  const getTendorAucProducts = (
    auctionId: number | string,
    currentPage: number,
    isLoadPreSelectedPage?: boolean
  ) => {
    setOpenToast(false);
    body = [];
    filteredValues = "";
    filteredParcelValues = "";

    if (localStorage.getItem("tabSelectedVal") !== "2") {
      filteredValues = localStorage.getItem("filteredValues");
      filteredValues = JSON.parse(filteredValues);

      if (filteredValues !== undefined) {
        if (filteredValues === null || filteredValues.length === 0) {
          filter = null;
        } else {
          filteredValues.map((item: any, index: number) => {
            if (item.name === "auctionId") {
              filteredValues.splice(index, 1);
            }
            return true;
          });
          filter = filteredValues;
        }
      }
    } else {
      filteredParcelValues = localStorage.getItem("filteredParcelValues");
      filteredParcelValues = JSON.parse(filteredParcelValues);

      if (filteredParcelValues !== undefined) {
        if (
          filteredParcelValues === null ||
          filteredParcelValues.length === 0
        ) {
          filter = null;
        } else {
          filteredParcelValues.map((item: any, index: number) => {
            if (item.name === "auctionId") {
              filteredParcelValues.splice(index, 1);
            }
            return true;
          });
          filter = filteredParcelValues;
        }
      }
    }
    getBody(auctionId, currentPage, endCount, isLoadPreSelectedPage);
  };

  const getBody = (
    auctionId: string | number,
    currentPage: number,
    endCount: number,
    isLoadPreSelectedPage?: boolean
  ) => {
    localStorage.setItem("activePageNumber", currentPage.toString());

    payload = {};

    if (localStorage.getItem("tabSelectedVal") !== "2") {
      filteredValues = localStorage.getItem("filteredValues");
      filteredValues = JSON.parse(filteredValues);
    } else {
      filteredParcelValues = localStorage.getItem("filteredParcelValues");
      filteredParcelValues = JSON.parse(filteredParcelValues);
    }

    if (
      localStorage.getItem("dropDownFilterVal") !== undefined &&
      localStorage.getItem("dropDownFilterVal") !== null
    ) {
      var tempArr = localStorage.getItem("dropDownFilterVal");
      if (tempArr !== null) var dropDownValues = JSON.parse(tempArr);
      var property = dropDownValues[0].property;
      var direction = dropDownValues[0].direction;
    }

    if (
      selectcurrentApiStartCountValue !== null &&
      selectcurrentApiStartCountValue !== 0
    ) {
      startCount = selectcurrentApiStartCountValue * selectItemPerPageValue;
    } else {
      startCount = selectcurrentApiStartCountValue;
    }

    if (
      selectcurrentApiStartCountValue != null &&
      selectcurrentApiStartCountValue !== 0
    ) {
      page = selectcurrentApiStartCountValue;
    } else {
      page = selectcurrentApiStartCountValue;
    }

    if (selectItemPerPageValue !== null) {
      let savedCount: any = selectItemPerPageValue;
      endCount = savedCount;
    } else {
      endCount = selectItemPerPageValue;
    }

    if (
      (filter === null &&
        (filteredValues == null ||
          filteredValues === undefined ||
          filteredValues === "null" ||
          filteredValues.length === 0)) ||
      (filter === null &&
        (filteredParcelValues == null ||
          filteredParcelValues === undefined ||
          filteredParcelValues === "null" ||
          filteredParcelValues.length === 0))
    ) {
      payload = {
        filters: {
          and: [
            {
              match: "exact",
              name: "auctionId",
              value: auctionId,
            },
          ],
        },
        page: {
          start: isLoadPreSelectedPage
            ? currentPage * 10
            : selectcurrentApiStartCountValue * selectItemPerPageValue,
          count: selectItemPerPageValue,
          sort: {
            orders: [
              {
                property:
                  property !== null && property !== undefined
                    ? property
                    : "serialNo",

                direction:
                  direction !== null && direction !== undefined
                    ? direction
                    : "ASC",
              },
            ],
          },
        },
      };
    } else {
      if (filteredValues !== null && filteredValues.length > 0) {
        body = filteredValues ? filteredValues : filter;
      } else {
        body = filteredParcelValues ? filteredParcelValues : filter;
      }

      body.map((item: any, index: number) => {
        if (item.name === "auctionId") {
          body.splice(index, 1);
        }
        return true;
      });

      if (localStorage.getItem("tabSelectedVal") !== "2") {
        body.push({
          match: "exact",
          name: "auctionId",
          value: props.match.params.auctionId,
        });
        payload = {
          filters: {
            and: body,
          },
          page: {
            start: isLoadPreSelectedPage
              ? currentPage * 10
              : selectcurrentApiStartCountValue * selectItemPerPageValue,
            count: selectItemPerPageValue,
            sort: {
              orders: [
                {
                  property:
                    property !== null && property !== undefined
                      ? property
                      : "serialNo",
                  direction:
                    direction !== null && direction !== undefined
                      ? direction
                      : "ASC",
                },
              ],
            },
          },
        };
      } else {
        let andArr = [];
        andArr.push({
          match: "exact",
          name: "auctionId",
          value: props.match.params.auctionId,
        });
        payload = {
          filters: {
            or: body,
            and: andArr,
          },
          page: {
            start: isLoadPreSelectedPage ? currentPage * 10 : startCount,
            count: endCount,
            sort: {
              orders: [
                {
                  property:
                    property !== null && property !== undefined
                      ? property
                      : "serialNo",
                  direction:
                    direction !== null && direction !== undefined
                      ? direction
                      : "ASC",
                },
              ],
            },
          },
        };
      }
    }
    var pattern = /^[0-9,]*$/g;
    let val = localStorage.getItem("optionValue");
    if (val !== "" && val !== "null" && val != null) {
      setOptionValue(val);
      let filterOR: any;
     let searchValue: any = val.replace(/ /g, '');
     if (pattern.test(searchValue)) {
       const myArray = searchValue.split(",");
       var filtered = myArray.filter(function (el: string) {
         return el != null && el !== "";
       });
       var convertedArr = filtered.map(function (item: string) {
         return parseInt(item, 10);
       });
       filterOR = [
         {
           match: "in",
           name: "serialNo",
           value: convertedArr,
         },
       ];
     } else {
       filterOR = [
         {
           match: "anywhere",
           name: "productDescription",
           value: val,
         },
         {
           match: "anywhere",
           name: "remarks",
           value: val,
         },
       ];
     }
      payload = {
        filters: {
          or: filterOR,
          and: [
            {
              match: "exact",
              name: "auctionId",
              value: props.match.params.auctionId,
            },
          ],
        },
        page: {
          start: isLoadPreSelectedPage
            ? currentPage * 10
            : selectcurrentApiStartCountValue * selectItemPerPageValue,
          count: selectItemPerPageValue,
          sort: {
            orders: [
              {
                property: "serialNo",
                direction: "ASC",
              },
            ],
          },
        },
      };
    }

    callApi(payload);
  };

  const textSearchListing = (value: any) => {
    var pattern = /^[0-9,]*$/g;
    if (!pattern.test(value)) {
      payload = {
        filters: {
          or: [
            {
              match: "anywhere",
              name: "remarks",
              value: value,
            },
            {
              match: "anywhere",
              name: "productDescription",
              value: value,
            },
          ],
        },
      };

      if (value === "" || value.length === 1) {
        setTextSearchArray([]);
      } else {
        if (value.length > 1) {
          Auth.postRequest(
            productTextSearch,
            payload,
            (status: any, response: any) => {
              if (status === 200) {
                setTextSearchArray(response.results);
              }
            }
          );
        }
      }
    }
  };

  const callApi = (payload: any) => {
    if (!oAuth()) {
      props.history.push("/");
    } else {
      Auth.postRequest(
        `${auctionTendorProductUrl}?auctionId=${props.match.params.auctionId}`,
        payload,
        (status: any, response: any) => {
          setIsLoading(false);
          if (status === 200) {
            setAuctionProducts(response.results);
            if (response.totalElements === 0) {
              totalElement = 0;
            }
            setTimeout(() => {
              setIsDataTableRefresh(!isDataTableRefresh);
            }, 2000);
            totalElement = response.totalElements;
            auctionName = response?.results[0]?.auctionName;
            auctionProductResult = response.results;
            if (response.results.length !== 0) {
              auctionDate = response.results[0].auctionStartDate;
              date = auctionDate?.split(" ", 2);
            }
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setOnAction(false);
          } else if (status === 404) {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(`${t("common:invalidRequest")}`);
            setAlertType("error");
            setOpenToast(true);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response[0].message);
            setAlertType("error");
            setOpenToast(true);
          }
        }
      );
    }
  };

  const autoCompleteSearch = (val: any) => {
    //handle local storege
    localStorage.setItem("optionValue", val);
    getTendorAucProducts(props.match.params.auctionId, 0);
  };

  const handleFilters = () => {
    setIsFiltersOpen(!isFiltersOpen);
    setShowSearchBox(!isShowSearchBox);
  };

  const filteredAuction = async (
    auctions: any,
    isFilter: boolean,
    values: any,
    isCustomFilter?: any
  ) => {
    localStorage.removeItem("apiStartCount");

    if (selectItemPerPageValue !== null) {
      let savedCount: any = selectItemPerPageValue;
      endCount = savedCount;
    }
    if (
      localStorage.getItem("dropDownFilterVal") !== undefined &&
      localStorage.getItem("dropDownFilterVal") !== null
    ) {
      var tempArr = localStorage.getItem("dropDownFilterVal");
      if (tempArr !== null) var dropDownValues = JSON.parse(tempArr);
      var property = dropDownValues[0].property;
      var direction = dropDownValues[0].direction;
    }

    if (values === null) {
      filter = null;
      payload = {
        filters: {
          and: [
            {
              match: "exact",
              name: "auctionId",
              value: props.match.params.auctionId,
            },
          ],
        },
        page: {
          start: startCount,
          count: endCount,
          sort: {
            orders:
              property === "serialNo"
                ? [
                    {
                      property:
                        property !== null && property !== undefined
                          ? property
                          : "serialNo",
                      direction:
                        direction !== null && direction !== undefined
                          ? direction
                          : "ASC",
                    },
                  ]
                : [
                    {
                      property:
                        property !== null && property !== undefined
                          ? property
                          : "serialNo",
                      direction:
                        direction !== null && direction !== undefined
                          ? direction
                          : "ASC",
                    },
                    {
                      property: "serialNo",
                      direction:
                        direction !== null && direction !== undefined
                          ? direction
                          : "ASC",
                    },
                  ],
          },
        },
      };
    } else {
      body = [];
      values.map((item: any, index: number) => {
        if (item.name === "auctionId") {
          values.splice(index, 1);
        }
        return true;
      });
      body = values;
      if (localStorage.getItem("tabSelectedVal") !== "2") {
        body.push({
          match: "exact",
          name: "auctionId",
          value: props.match.params.auctionId,
        });
        payload = {
          filters: {
            and: body,
          },
          page: {
            start: startCount,
            count: endCount,
            sort: {
              orders:
                property === "serialNo"
                  ? [
                      {
                        property:
                          property !== null && property !== undefined
                            ? property
                            : "serialNo",
                        direction:
                          direction !== null && direction !== undefined
                            ? direction
                            : "ASC",
                      },
                    ]
                  : [
                      {
                        property:
                          property !== null && property !== undefined
                            ? property
                            : "serialNo",
                        direction:
                          direction !== null && direction !== undefined
                            ? direction
                            : "ASC",
                      },
                      {
                        property: "serialNo",
                        direction:
                          direction !== null && direction !== undefined
                            ? direction
                            : "ASC",
                      },
                    ],
            },
          },
        };
      } else {
        let andArr = [];
        andArr.push({
          match: "exact",
          name: "auctionId",
          value: props.match.params.auctionId,
        });
        payload = {
          filters: {
            and: andArr,
            or: body,
          },
          page: {
            start: startCount,
            count: endCount,
            sort: {
              orders:
                property === "serialNo"
                  ? [
                      {
                        property:
                          property !== null && property !== undefined
                            ? property
                            : "serialNo",
                        direction:
                          direction !== null && direction !== undefined
                            ? direction
                            : "ASC",
                      },
                    ]
                  : [
                      {
                        property:
                          property !== null && property !== undefined
                            ? property
                            : "serialNo",
                        direction:
                          direction !== null && direction !== undefined
                            ? direction
                            : "ASC",
                      },
                      {
                        property: "serialNo",
                        direction:
                          direction !== null && direction !== undefined
                            ? direction
                            : "ASC",
                      },
                    ],
            },
          },
        };
      }
      if (isCustomFilter === undefined) {
        filter = body;
        if (localStorage.getItem("tabSelectedVal") !== "2") {
          localStorage.setItem("filteredValues", JSON.stringify(body));
        } else {
          localStorage.setItem("filteredParcelValues", JSON.stringify(body));
        }
      }
    }
    await filterCAllback(payload);
  };

  const filterCAllback = (dataVal: any) => {
    if (selectcurrentApiStartCountValue === 0) {
      callApi(dataVal);
    } else {
      dispatch(setCurrentApiStartCount({ currentPage: 0 }));
    }
  };

  const getTableBodyHeight = () => {
    var h = window.innerHeight;
    let heightOfInnerTable: any;
    if (isTableExpanded) {
      heightOfInnerTable = h - 380;
    } else {
      heightOfInnerTable = h - 190;
    }
    if (auctionProducts.length > 7) {
      return `${heightOfInnerTable}px`;
    }
  };

  const options: MUIDataTableOptions = {
    filter: false,
    download: "false",
    filterType: "textField",
    print: "false",
    viewColumns: "false",
    count: totalElement,
    page: page,
    serverSide: true,
    search: false,
    rowsPerPage: selectItemPerPageValue,
    rowsPerPageOptions: [0],
    selectableRows: "multiple",
    selectableRowsHeader: true,
    selectableRowsOnClick: false,
    selectableRowsHideCheckboxes: false,
    isRowSelectable: (dataIndex: any, selectedRows: any) => {
      const disableRowIndexsArray = getDisableRowIndex();
      return disableRowIndexsArray.includes(dataIndex) ? false : true;
    },
    onChangePage: (currentPage: number) => {
      localStorage.setItem(
        "apiStartCount",
        JSON.stringify(currentPage * itemsPerPageUseRef.current)
      );
      dispatch(setCurrentApiStartCount({ currentPage }));
      // getTendorAucProducts(props.match.params.auctionId, currentPage);
    },
    onSearchChange: (searchTxt: any) => {
      return searchTxt;
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
      return (
        <div className="mailIconDiv">
          <IconButton color="primary">
            <i className="zmdi zmdi-email"></i>
          </IconButton>
        </div>
      );
    },
    setRowProps: (row: any, dataIndex: any, rowIndex: any) => {
      if (row[columnIndexes.previousHighestBidder] === undefined) {
        if (row[columnIndexes.holdPreviousBidder] === undefined) {
          if (
            row[columnIndexes.auctionUserId] !==
            props.match.params.auctionUserId
          ) {
            return { style: { background: "white" } };
          } else {
            return { style: { background: row[columnIndexes.rowColor] } };
          }
        } else {
          if (
            props.match.params.auctionUserId ===
            row[columnIndexes.holdPreviousBidder]
          ) {
            return { style: { background: "#ffeb9c" } };
          } else {
            return { style: { background: row[columnIndexes.rowColor] } };
          }
        }
      } else {
        if (
          props.match.params.auctionUserId ===
          row[columnIndexes.previousHighestBidder]
        ) {
          return { style: { background: "#FBE4D5" } };
        } else {
          return { style: { background: row[columnIndexes.rowColor] } };
        }
      }
    },
    onColumnSortChange: (price: any, direction: any) => {
      let order = "";
      if (direction === "asc") {
        order = "desc";
      } else {
        order = "asc";
      }
      sort(price, order);
    },
    onRowSelectionChange: (
      currentRowsSelected: any,
      allRowsSelected: any,
      rowsSelected: any
    ) => {
      setOpenToast(false);
      indexsForBulkBidItems = rowsSelected;
      indexsForBulkBidItems.map((indexs: any) => {
        let {
          sellerAuctionUserId,
          previousHighestBidder,
          auctionUserId,
          holdPreviousBidder,
        } = auctionProducts[indexs];
        if (sellerAuctionUserId === props.match.params.auctionUserId) {
          return { ...options, isRowSelectable: "false" };
        } else if (previousHighestBidder !== undefined) {
          if (props.match.params.auctionUserId === previousHighestBidder) {
            return { ...options, isRowSelectable: "false" };
          }
        } else if (holdPreviousBidder !== undefined) {
          if (props.match.params.auctionUserId === holdPreviousBidder) {
            return { ...options, isRowSelectable: "false" };
          }
        } else if (auctionUserId === props.match.params.auctionUserId) {
          return { ...options, isRowSelectable: "false" };
        }
      });
      if (indexsForBulkBidItems.length > 0) {
        setShowBulkBidButton(true);
      } else {
        setShowBulkBidButton(false);
      }
      if (indexsForBulkBidItems.length === 0) {
        setShowBulkBidButton(false);
      }
      if (indexsForBulkBidItems.length > 10) {
        setShowAlertMessage(
          `${t("common:Tender:validation:productSelection")}`
        );
        setAlertType("error");
        setOpenToast(true);
      }
    },
    tableBodyHeight: getTableBodyHeight(),
    textLabels: {
      body: {
        noMatch: `${t("common:preview:noProductFound")}`,
        toolTip: "Sort",
      },
    },
  };

  const onGridSelectionChange = (rowsSelected: any) => {
    indexsForBulkBidItems = rowsSelected;
    setOpenToast(false);
    if (indexsForBulkBidItems.length >= 0) {
      setShowBulkBidButton(true);
    } else {
      setShowBulkBidButton(false);
    }
    if (indexsForBulkBidItems.length === 0) {
      setShowBulkBidButton(false);
    }
    if (indexsForBulkBidItems.length > 10) {
      setShowAlertMessage(`${t("common:Tender:validation:productSelection")}`);
      setAlertType("error");
      setOpenToast(true);
    }
  };

  const boxColor = (items: any) => {
    const {
      auctionUserId,
      rowColor,
      previousHighestBidder,
      holdPreviousBidder,
    } = items;
    if (previousHighestBidder === undefined) {
      if (holdPreviousBidder === undefined) {
        if (auctionUserId !== props.match.params.auctionUserId) {
          return "white";
        } else {
          return rowColor;
        }
      } else {
        if (props.match.params.auctionUserId === holdPreviousBidder) {
          return "#ffeb9c";
        } else {
          return rowColor;
        }
      }
    } else {
      if (props.match.params.auctionUserId === previousHighestBidder) {
        return "#FBE4D5";
      } else {
        return rowColor;
      }
    }
  };

  const getDisableRowIndex = () => {
    return auctionProducts.map((items: any, index: number) => {
      if (isReadOnlyUser) {
        return index;
      } else {
        if (items.sellerAuctionUserId === props.match.params.auctionUserId) {
          return index;
        } else if (items.previousHighestBidder !== undefined) {
          if (
            props.match.params.auctionUserId === items.previousHighestBidder
          ) {
            return index;
          }
        } else if (items.holdPreviousBidder !== undefined) {
          if (props.match.params.auctionUserId === items.holdPreviousBidder) {
            return index;
          }
        } else if (items.auctionUserId === props.match.params.auctionUserId) {
          return index;
        }
      }
    });
  };

  const filterSort = (price: any, direction: any) => {
    let order = "";
    if (direction === "asc") {
      order = "desc";
    } else {
      order = "asc";
    }
    sort(price, order);
  };

  const sort = (value: any, direction: any) => {
    sortData(value, direction);
  };

  const sortData = (values: any, direction: any) => {
    let tempArr: any;
    if (direction === "asc") {
      tempArr = [{ property: values, direction: "ASC" }];
      localStorage.setItem("dropDownFilterVal", JSON.stringify(tempArr));
    } else {
      tempArr = [{ property: values, direction: "DESC" }];
      localStorage.setItem("dropDownFilterVal", JSON.stringify(tempArr));
    }
    localStorage.removeItem("apiStartCount");
    if (selectcurrentApiStartCountValue === 0) {
      getTendorAucProducts(props.match.params.auctionId, 0);
    } else {
      dispatch(setCurrentApiStartCount({ currentPage: 0 }));
    }
  };

  const columns: MUIDataTableColumnDef[] = [
    {
      name: "serialNo",
      label: "Serial No",
      options: {
        filter: true,
        sort: true,
        display: true,
      },
    },
    {
      name: "perId",
      label: "Product Id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "auctionUserId",
      label: "Auction User Id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "",
      label: `${t("common:Tender:tableColumnNames:ActionsTender")}`,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div
              style={{
                display: "flex",
                gridGap: "10px",
                justifyContent: "center",
              }}
            >
              <div
                title={`Note`}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  openProductDetail(
                    props.match.params.auctionId,
                    tableMeta.rowData[1],
                    props.match.params.auctionDate
                  )
                }
              >
                <FontAwesomeIcon
                  icon={faEditProps}
                  style={{ color: "#014a99" }}
                />
              </div>
              <div
                title={`Add Product into Wishlist`}
                style={{ cursor: "pointer" }}
              >
                {isReadOnlyUser ? (
                  <FontAwesomeIcon
                    icon={faHeartProps}
                    style={{ color: "gray" }}
                    onClick={() => {
                      renderReadOnlyUserToast(
                        tableMeta.rowData[columnIndexes.sellerAuctionUserId]
                      );
                    }}
                  />
                ) : (
                  <>
                    {tableMeta.rowData[columnIndexes.sellerAuctionUserId] !==
                    props.match.params.auctionUserId ? (
                      <>
                        {getWatchedProduct(
                          tableMeta.rowData[columnIndexes.watched],
                          tableMeta.rowData[columnIndexes.productId],
                          props.match.params.auctionId,
                          tableMeta.rowData[1]
                        )}
                      </>
                    ) : (
                      <FontAwesomeIcon
                        icon={faHeartProps}
                        style={{ color: "gray" }}
                        onClick={() => {
                          renderReadOnlyUserToast(
                            tableMeta.rowData[columnIndexes.sellerAuctionUserId]
                          );
                        }}
                      />
                    )}
                  </>
                )}
              </div>
              <div
                title={`Share Product`}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  shareButtonAction(tableMeta.rowData[columnIndexes.productId])
                }
              >
                <FontAwesomeIcon
                  icon={faShareSquareProps}
                  style={{ color: "#014a99" }}
                />
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "code",
      label: `${t("common:Tender:tableColumnNames:productId")}`,
      options: {
        filter: true,
        sort: false,
        setCellProps: () => ({
          style: { minWidth: "150px", maxWidth: "150px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <span
              className="linkCss"
              onClick={() =>
                openProductDetail(
                  props.match.params.auctionId,
                  tableMeta.rowData[1],
                  props.match.params.auctionDate
                )
              }
              onContextMenu={(event: any) =>
                rightClickEvent(event, tableMeta.rowData[1])
              }
            >
              {value}
            </span>
          );
        },
      },
    },
    {
      name: "lab",
      label: `${t("common:Tender:tableColumnNames:lab")}`,
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: any, tableMeta: any) => {
          if (
            value !== "AGT" &&
            value !== "agt" &&
            value !== "" &&
            value !== undefined
          ) {
            return (
              <span
                className="linkCss"
                onClick={() =>
                  openCertificateLinkPopup(
                    value,
                    tableMeta.rowData[columnIndexes.certificate]
                  )
                }
              >
                {value}
              </span>
            );
          } else {
            return <span>{value}</span>;
          }
        },
      },
    },
    {
      name: "certificate",
      label: `${t("common:Tender:tableColumnNames:certification")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "description",
      label: `${t("common:Tender:tableColumnNames:description")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "productDescription",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "carat",
      label: `${t("common:Tender:tableColumnNames:carat")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
      },
    },
    {
      name: "color",
      label: `${t("common:Tender:tableColumnNames:color")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <>{getAbbreviation(tableMeta.rowData[columnIndexes.colorValue])}</>
          );
        },
      },
    },
    {
      name: "clarity",
      label: `${t("common:Tender:tableColumnNames:clarity")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
      },
    },
    {
      name: "remarks",
      label: `Remarks`,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          let isClickableRemark: any;
          if (tableMeta.rowData[columnIndexes.parcelType] === "Parcel") {
            isClickableRemark = makeLinkClickable(
              tableMeta.rowData[columnIndexes.productDescription]
            );
          } else {
            isClickableRemark = makeLinkClickable(
              tableMeta.rowData[columnIndexes.remarks]
            );
          }
          return (
            <>
              {isClickableRemark !== false ? (
                <span
                  style={{ color: "blue", cursor: "pointer" }}
                  onClick={() => {
                    window.open(
                      isClickableRemark,
                      "DescriptiveWindowName",
                      "height=700px,width=1024px,scrollbars,toolbar,status,resizable"
                    );
                  }}
                >
                  <EllipsisText
                    text={getDescription(
                      tableMeta.rowData[columnIndexes.parcelType],
                      tableMeta.rowData[columnIndexes.productDescription],
                      tableMeta.rowData[columnIndexes.remarks]
                    )}
                    length={20}
                    tail={"..."}
                  />
                </span>
              ) : (
                <EllipsisText
                  text={getDescription(
                    tableMeta.rowData[columnIndexes.parcelType],
                    tableMeta.rowData[columnIndexes.productDescription],
                    tableMeta.rowData[columnIndexes.remarks]
                  )}
                  length={20}
                  tail={"..."}
                />
              )}
            </>
          );
        },
      },
    },
    {
      name: "noOfPieces",
      label: `${t("common:Tender:tableColumnNames:noOfPieces")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return <>{value !== 0 ? value : "-"}</>;
        },
      },
    },
    {
      name: "shape",
      label: `${t("common:Tender:tableColumnNames:shape")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <>
              {getAbbreviation(
                tableMeta.rowData[columnIndexes.shapeAbbreviation]
              )}
            </>
          );
        },
      },
    },
    {
      name: "sieve",
      label: `${t("common:Tender:tableColumnNames:Sieve")}`,
      options: {
        filter: true,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return <>{value !== "-" ? value : ""}</>;
        },
      },
    },
    {
      name: "cutGrade",
      label: `${t("common:Tender:tableColumnNames:cutGrade")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return <>{getAbbreviation(value)}</>;
        },
      },
    },
    {
      name: "polish",
      label: `${t("common:Tender:tableColumnNames:polish")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <>
              {getAbbreviation(
                tableMeta.rowData[columnIndexes.polishAbbreviation]
              )}
            </>
          );
        },
      },
    },
    {
      name: "symmetryAbbreviation",
      label: `${t("common:Tender:tableColumnNames:symmetryAbbreviation")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return <>{getAbbreviation(value)}</>;
        },
      },
    },
    {
      name: "flour",
      label: `${t("common:Tender:tableColumnNames:flour")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <>
              {getAbbreviation(
                tableMeta.rowData[columnIndexes.flourAbbreviation]
              )}
            </>
          );
        },
      },
    },
    {
      name: "currency",
      label: "currency",
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value: any) => {
          return <div>{value.code}</div>;
        },
      },
    },
    {
      name: "caratMinimumPrice",
      label: `${t("common:Tender:tableColumnNames:pricePct")}`,
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({
          style: { minWidth: "120px", maxWidth: "120px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {convertedValue(
                tableMeta.rowData[columnIndexes.currency],
                value,
                tableMeta.rowData[columnIndexes.exchangeRate][0].rate
              )}
            </div>
          );
        },
      },
    },
    {
      name: "myLatestBid",
      label: `${t("common:Tender:tableColumnNames:placeBid")}`,
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { minWidth: "130px", maxWidth: "140px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <>
              {isDataRefresh ? (
                <div>
                  {value === undefined || value === null
                    ? 0
                    : handelMyBidsLabel(
                        myLatestBidForProduct,
                        tableMeta.rowData[columnIndexes.productId],
                        tableMeta.rowData[columnIndexes.currency],
                        tableMeta.rowData[columnIndexes.exchangeRate][0].rate
                      )}
                </div>
              ) : (
                <div>
                  {value === undefined || value === null
                    ? 0
                    : handelMyBidsLabel(
                        myLatestBidForProduct,
                        tableMeta.rowData[columnIndexes.productId],
                        tableMeta.rowData[columnIndexes.currency],
                        tableMeta.rowData[columnIndexes.exchangeRate][0].rate
                      )}
                </div>
              )}
              {getBidNowButtonDisable(
                tableMeta.rowData[columnIndexes.sellerAuctionUserId],
                props.match.params.auctionUserId,
                tableMeta.rowData[columnIndexes.auctionUserId],
                tableMeta,
                getReturnMyLatestStoredBid(
                  myLatestBidForProduct,
                  tableMeta.rowData[columnIndexes.productId]
                ),
                tableMeta.rowData[columnIndexes.currentBidPrice],
                tableMeta.rowData[columnIndexes.productId],
                tableMeta.rowData[columnIndexes.previousHighestBidder],
                tableMeta.rowData[columnIndexes.holdPreviousBidder]
              )}
            </>
          );
        },
      },
    },
    {
      name: "notes",
      label: `${t("common:Tender:tableColumnNames:notes")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "currentBidPrice",
      label: `${t("common:Tender:tableColumnNames:liveHighestBid")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {convertedValue(
                tableMeta.rowData[columnIndexes.currency],
                value,
                tableMeta.rowData[columnIndexes.exchangeRate][0].rate
              )}
            </div>
          );
        },
      },
    },
    {
      name: "rapnetPercentage",
      label: `${t("common:Tender:tableColumnNames:rapOff")}`,
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {getRapNet(tableMeta.rowData[columnIndexes.rapnetPercentage])}
            </div>
          );
        },
      },
    },
    {
      name: "noOfBidders",
      label: `${t("common:newCommanTrans:noOfBiddersBids")}`,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {getNoOfBiddersAndNoOfBids(
                tableMeta.rowData[columnIndexes.noOfBids],
                tableMeta.rowData[columnIndexes.noOfBidders]
              )}
            </div>
          );
        },
      },
    },
    {
      name: "rowColor",
      label: "Bid Color",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "exchangeRates",
      label: "Exchange Rate",
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value: any) => {
          return <div>{value[0].rate}</div>;
        },
      },
    },
    {
      name: "parcelType",
      label: "",
      options: {
        filter: false,
        display: false,
      },
    },

    {
      name: "noOfBids",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "watched",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "sellerAuctionUserId",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "rapnetPercentage",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "tenderSecondHighestBid",
      label: `${t("common:Tender:tableColumnNames:liveHighestBid")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {convertedValue(
                tableMeta.rowData[columnIndexes.currency],
                value,
                tableMeta.rowData[columnIndexes.exchangeRate][0].rate
              )}
            </div>
          );
        },
      },
    },
    {
      name: "previousHighestBidder",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "holdPreviousBidder",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "shapeAbbreviation",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "polishAbbreviation",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "flourAbbreviation",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "colorValue",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
  ];

  //get bid now button disable
  const getBidNowButtonDisable = (
    sellerId: any,
    auctionUserIdForProduct: any,
    tableAuctionUserId: any,
    tableDataForUIBox: any,
    myBidsForProduct: any,
    currentBidPriceForProduct: any,
    currentproductId: any,
    previousBidderId: any,
    holdPreviousBidder: any
  ) => {
    const Obj = myLatestBidForProduct.filter(
      (item: any) => item.productId === currentproductId
    );
    const mybidPriceforProduct = Obj.map((item: any, index: number) => {
      return item.myLatestBid;
    });
    renderAutomaticBidPopup(tableDataForUIBox);
    if (isReadOnlyUser) {
      return (
        <StyledBtnContainer
          onClick={() => {
            renderReadOnlyUserToast(sellerId);
          }}
        >
          <StyledButtonGray>
            {t("common:inquiry:button:bidNow")}
          </StyledButtonGray>
        </StyledBtnContainer>
      );
    } else {
      if (sellerId === auctionUserIdForProduct) {
        return (
          <StyledBtnContainer
            onClick={() => {
              renderReadOnlyUserToast(sellerId);
            }}
          >
            <StyledButtonGray>
              {t("common:inquiry:button:bidNow")}
            </StyledButtonGray>
          </StyledBtnContainer>
        );
      } else if (holdPreviousBidder !== undefined) {
        if (props.match.params.auctionUserId === holdPreviousBidder) {
          return (
            <StyledBtnContainer>
              <StyledButtonGray>
                {t("common:inquiry:button:bidNow")}
              </StyledButtonGray>
            </StyledBtnContainer>
          );
        } else {
          return (
            <StyledBtnContainer>
              <StyledButton onClick={() => handleBidClick(tableDataForUIBox)}>
                {t("common:inquiry:button:bidNow")}
              </StyledButton>
            </StyledBtnContainer>
          );
        }
      } else if (previousBidderId !== undefined) {
        if (props.match.params.auctionUserId === previousBidderId) {
          return (
            <StyledBtnContainer>
              <StyledButtonGray>
                {t("common:inquiry:button:bidNow")}
              </StyledButtonGray>
            </StyledBtnContainer>
          );
        } else {
          return (
            <StyledBtnContainer>
              <StyledButton onClick={() => handleBidClick(tableDataForUIBox)}>
                {t("common:inquiry:button:bidNow")}
              </StyledButton>
            </StyledBtnContainer>
          );
        }
      } else if (tableAuctionUserId === props.match.params.auctionUserId) {
        return (
          <StyledBtnContainer>
            <StyledButtonGray>
              {t("common:inquiry:button:bidNow")}
            </StyledButtonGray>
          </StyledBtnContainer>
        );
      } else if (mybidPriceforProduct[0] > currentBidPriceForProduct) {
        return (
          <StyledBtnContainer>
            <StyledButtonGray>
              {t("common:inquiry:button:bidNow")}
            </StyledButtonGray>
          </StyledBtnContainer>
        );
      } else {
        if (tableAuctionUserId === props.match.params.auctionUserId) {
          return (
            <StyledBtnContainer>
              <StyledButtonGray>
                {" "}
                {t("common:inquiry:button:bidNow")}
              </StyledButtonGray>
            </StyledBtnContainer>
          );
        } else {
          return (
            <StyledBtnContainer>
              <StyledButton onClick={() => handleBidClick(tableDataForUIBox)}>
                {t("common:inquiry:button:bidNow")}
              </StyledButton>
            </StyledBtnContainer>
          );
        }
      }
    }
  };

  //get My All MyBid
  const handelMyBidsLabel = (
    myStoredBids: any,
    currentProductId: any,
    currency: any,
    exchangeRate: any
  ) => {
    const Obj = myLatestBidForProduct.filter(
      (item: any) => item.productId === currentProductId
    );
    const mybidPriceforProduct = Obj.map((item: any, index: number) => {
      return item.productId;
    });

    return getMyLatestStoredBids(
      myLatestBidForProduct,
      currentProductId,
      currency,
      exchangeRate,
      mybidPriceforProduct
    );
  };

  //get Watched Product
  const getWatchedProduct = (
    watched: any,
    productId: any,
    auctionId: any,
    serialNo: any
  ) => {
    if (watched === true) {
      return (
        <FontAwesomeIcon
          icon={faHeartProps}
          style={{ color: "red", cursor: "pointer" }}
          onClick={() => removeFromWatchlist(productId, auctionId)}
        />
      );
    } else {
      return (
        <FontAwesomeIcon
          icon={faHeartProps}
          style={{ color: "gray" }}
          onClick={() => addToWatchList(productId, auctionId, serialNo)}
        />
      );
    }
  };

  const shareButtonAction = (perId: any) => {
    const { t } = props;
    let languageCode =
      localStorage.getItem("language") === "EN"
        ? "en"
        : localStorage.getItem("language") === "zh_CN"
        ? "zh_CN"
        : "jp";
    copy(
      `${window.location.hostname}/${languageCode}/product/${perId}/${date[0]}/detail`
    );
    setAlertType("success");
    setOpenToast(true);
    setShowAlertMessage(`${t("common:preview:linkCopied")}`);
    setTimeout(() => {
      setOpenToast(false);
    }, 2000);
  };

  const getNoOfBiddersAndNoOfBids = (noOfBidders: any, noOfBids: any) => {
    return `${noOfBidders}/${noOfBids}`;
  };

  //this funtion render product details page
  const openProductDetail = (
    auctionId: string,
    perId: string,
    auctionDate: string
  ) => {
    localStorage.setItem("auctionUserId", props.match.params.auctionUserId);
    props.history.push(
      `/preview/tender/details/${auctionId}/${perId}/${date[0]}?isAuction=true&uniqid=${props.match.params.auctionUserId}`
    );
  };
  const openDetailsView = (
    auctionId: string,
    perId: string,
    auctionDate: string
  ) => {
    localStorage.setItem("auctionUserId", props.match.params.auctionUserId);
    const language = localStorage.getItem("language");

    const languageCode =
      language === "EN" ? "en" : language === "zh_CN" ? "zh_CN" : "jp";
    window.open(
      `/${languageCode}/preview/tender/details/${auctionId}/${perId}/${date[0]}?isAuction=true&uniqid=${props.match.params.auctionUserId}`,
      "_blank"
    );
  };

  const rightClickEvent = (
    event: React.MouseEvent<HTMLDivElement>,
    productId: string
  ) => {
    event.preventDefault();
    setMouseState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
    setCurrentProductId(productId);
  };

  const handleClose = () => {
    setMouseState(initialState);
  };

  const closeModal = () => {
    Auth.logout();
    props.history.replace("/");
  };

  const tabItemClicks = (value: String) => {
    if (value === "2") {
      localStorage.setItem("tabSelectedVal", "2");
      setShowParcelItem(true);
    } else {
      localStorage.setItem("tabSelectedVal", "1");
      setShowParcelItem(false);
      dispatch(reSetIsMybids());
    }
    dispatch(setCurrentApiStartCount({ currentPage: 0 }));
  };

  const tabItemClick = (value: any) => {
    if (value === "1") {
      setTabValue({
        allProducts: true,
        myBids: false,
      });
      dispatch(reSetIsMybids());
    } else {
      setTabValue({
        allProducts: false,
        myBids: true,
      });
    }
  };

  const getLeftTime = (startDate: any) => {
    let date: string | null = "";
    let time: string | null = "";
    let hour: any = "";
    let minutes: any = "";
    let timeDifference: any = "";
    let timezone: any = "";

    if (startDate !== null || startDate !== undefined) {
      let previewTime = moment.utc(startDate);
      if (timezone !== null) {
        timezone = localStorage.getItem("timezoneName");
      }
      if (previewTime !== null || previewTime !== undefined) {
        let result = moment.tz(previewTime, timezone);
        let resultFormatter = result.format();
        if (resultFormatter !== "Invalid date") {
          let splitDateTime = resultFormatter.split("T", 2);
          let splitTime: any = "";
          if (splitDateTime[1].includes("+")) {
            splitTime = splitDateTime[1].split("+", 2);
          } else {
            splitTime = splitDateTime[1].split("-", 2);
          }
          date = splitDateTime[0];
          time = splitTime[0];
          let dateTime = `${date} ${time}`;
          //let start: any = moment(dateTime);
          let end: any = moment(dateTime);
          timezone = localStorage.getItem("timezoneName");
          //let end: any = moment(new Date().toLocaleString("en-US", { timeZone: timezone }));
          let start: any = moment(
            new Date().toLocaleString("en-US", {
              timeZone: timezone !== null ? timezone : "",
            })
          );
          hour = start.diff(end, "hours");
          minutes = start.diff(end, "minutes");
          timeDifference = localStorage.getItem("timeDifference");
          timeDifference = timeDifference / 1000;
          timeDifference = parseInt(timeDifference);
          //var timeDiff = start - end;
          var timeDiff = end - start;
          seconds = Math.round(timeDiff);
          {
            timeDifference[0] === "-"
              ? (seconds = seconds - timeDifference)
              : (seconds = seconds + timeDifference);
          }
        }
      }
    }
    setTimeout(() => {
      getLeftTime(startDate);
    }, 1000);
  };

  const renderer = ({
    formatted: { days, hours, minutes, seconds },
    completed,
  }: any) => {
    if (completed) {
      if (
        days === "00" &&
        hours === "00" &&
        minutes === "00" &&
        seconds === "00"
      ) {
        getTimePopup();
        return <span>00:00:00:00</span>;
      }
    } else {
      return (
        <span>
          {days}:{hours}:{minutes}:{seconds}
        </span>
      );
    }
  };

  const getTimePopup = () => {
    const callBack = (response: any) => {
      const { state, tenderExtended } = response;
      if (
        state === "Started" &&
        tenderExtended === true &&
        isUserClosedExtendedPopup === false
      ) {
        setOpenTenderExtended(true);
      } else if (state === "Ended") {
        setOpenEndedModal(true);
        setOpenTenderExtended(false);
      }
      timeLeftLableColor = tenderExtended;
    };
    setTimeout(() => {
      getAuctionEndTime(props.match.params.auctionId, callBack);
    }, 3000);
  };

  //Auction end popup redirection funtion
  const TenderTimeExtended = () => {
    setIsUserClosedExtendedPopup(true);
    getAllUpdatedData();
    if (selectcurrentApiStartCountValue === 0) {
      getTendorAucProducts(props.match.params.auctionId, 0);
    } else {
      dispatch(setCurrentApiStartCount({ currentPage: 0 }));
    }

    const interval = setInterval(() => {
      window.location.reload();
      clearInterval(interval);
    }, 1000);
    // dispatch(setCurrentApiStartCount({ currentPage: 0 }));

    setOpenTenderExtended(false);
  };

  const TenderauctionEndedModal = () => {
    props.history.push("/auction");
  };

  const setItemsPerPageHandler = (itemsPerPage: number) => {
    localStorage.setItem("activePageNumber", "0");
    setCurrentPage(0);
    setItemsPerPage(itemsPerPage);
    itemsPerPageUseRef.current = itemsPerPage;
    dispatch(setItemPerPage({ itemsPerPage }));
    dispatch(resetCurrentApiStartCount());
  };

  function setCurrentPage(currentPage: number) {
    return currentPage;
  }

  function setItemsPerPage(itemsPerPage: number) {
    return itemPerPage(true, 0, itemsPerPage);
  }

  const itemPerPage = (value: boolean, start: number, itemPerPage: number) => {
    if (value === true) {
      localStorage.setItem("itemPerPageSelected", JSON.stringify(itemPerPage));
      getUpdatedProducts(value, start, itemPerPage);
    }
  };

  const getUpdatedProducts = (value: any, start: any, endRecords: any) => {
    if (value === true) {
      getProducts(start, endRecords);
    }
  };

  const getProducts = (start: number, itemsPerPage: number) => {
    startCount = start;
    endCount = itemsPerPage;
    localStorage.setItem("apiStartCount", JSON.stringify(start));
    let currentPage = start / itemsPerPage;
    setIsLoading(true);
    if (currentPage === selectcurrentApiStartCountValue) {
      setIsLoading(false);
    }
    dispatch(setCurrentApiStartCount({ currentPage }));
    dispatch(setItemPerPage({ itemsPerPage }));
    onGridSelectionChange(0);
    PubSub.publish("resetGridBoxIndex", []);
    dispatch(resetTenderDiamondGridProductAllProductIndexes());
    dispatch(resetTenderDiamondAllProductSelectAll());
  };

  const closebidPopup = () => {
    setshowTenderSlider(false);
    setShowBulkBidPopup(false);
    setSingleBiddingPopup(false);
    redirectProduct = [];
    PubSub.publish("resetGridBoxIndex", []);
    onGridSelectionChange(0);
  };

  const handleMyBids = (auctionsProduct: any) => {
    if (auctionsProduct.length > 0) {
      setAuctionProducts(auctionsProduct);
    }
  };

  const addToWatchList = (
    productId: string | number,
    auctionId: string | number,
    serialNo: string | number
  ) => {
    setOnAction(true);
    setOpenToast(false);
    if (!oAuth()) {
      props.history.push("/");
    } else {
      Auth.postRequest(
        `${productUrl}/${auctionId}/${productId}/watch`,
        "payload",
        (status: any, response: any) => {
          if (response !== undefined) {
            if (status === 200) {
              callApi(payload);
              setIsLoading(false);
              setOnAction(false);
              setShowAlertMessage(`${t("common:preview:addedToWatchMsg")}`);
              setAlertType("success");
              setOpenToast(true);
            }
          }
        }
      );
    }
  };

  const removeFromWatchlist = (
    productId: string | number,
    auctionId: string | number
  ) => {
    setOnAction(true);
    setOpenToast(false);
    if (Auth.loggedIn() === null) {
      props.history.push("/");
    } else {
      Auth.postRequest(
        `${productUrl}/${auctionId}/${productId}/unwatch`,
        "payload",
        (status: any, response: any) => {
          if (status === 200) {
            callApi(payload);
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response.data.message);
            setAlertType("success");
            setOpenToast(true);
          }
        }
      );
    }
  };

  //watchlist redirection Fucntion
  const watchlist = () => {
    localStorage.removeItem("selectedFilterSort");
    // props.history.push(
    //   `/watchlist/${props.match.params.auctionId}/${props.match.params.auctionUserId}/${date[0]}/Popcorn`
    // );
    props.history.push("/my-page");
    dispatch(resetItemPerPage());
    dispatch(resetCurrentApiStartCount());
  };

  const listGridview = () => {
    onGridSelectionChange(0);
    PubSub.publish("resetGridBoxIndex", []);
    selectPageUseRef.current = startCount;
    dispatch(resetTenderIsGridView());    
  };

  const Gridview = () => {
    onGridSelectionChange(0);
    PubSub.publish("resetGridBoxIndex", []);
    dispatch(setTenderIsGridView({ gridView: false }));
  };

  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    window.addEventListener("scroll", isStickytwo);
    return () => {
      window.removeEventListener("scroll", isSticky);
      window.removeEventListener("scroll", isStickytwo);
    };
  });

  const isSticky = (e: any) => {
    return true;
  };

  const isStickytwo = (e: any) => {
    return true;
  };

  //open top toggle button

  useEffect(() => {
    let isShowDrawerIcon: any = localStorage.getItem("isShowDrawerIcon");
    isShowDrawerIcon = JSON.parse(isShowDrawerIcon);
    if (isShowDrawerIcon !== null) {
      if (isShowDrawerIcon) {
        const accordionHeader: any = document.querySelector(".AccordionHeader");
        if (accordionHeader !== null) {
          accordionHeader.style.width = isShowDrawerIcon
            ? "calc(100% - 60px)"
            : "calc(100% - 240px)";
        }
      }
    }
    if (tabValue.allProducts === false) {
      setIsTopElementHide(true);
      setIsTableExpanded(false);
    } else {
      setIsTopElementHide(false);
    }
  });

  const renderReadOnlyUserToast = async (id: any) => {
    var joinedAuctions: any = localStorage.getItem("joinedAuctions");
    joinedAuctions = JSON.parse(joinedAuctions);
    if (joinedAuctions !== null) {
      joinedAuctions.filter((items: any, index: number) => {
        if (id === items.auctionUserId) {
          isAuctionUserId = true;
        }
        return true;
      });
    } else {
      if (id === props.match.params.auctionUserId) {
        isAuctionUserId = true;
      } else {
        isAuctionUserId = false;
      }
    }
    await renderPopup();
  };

  const renderPopup = () => {
    if (isReadOnlyUser) {
      setOpenReadOnlyUserToast(true);
    } else if (isAuctionUserId) {
      setOpenReadOnlyUserToast(true);
    } else {
      setOpenReadOnlyUserToast(false);
    }
    setTimeout(() => {
      setOpenReadOnlyUserToast(false);
    }, 3000);
  };

  const selectAllInGridView = () => {
    let arr: any = [];
    auctionProducts.map((productVal: any, index: any) => {
      if (arr.length < 10) {
        if (isReadOnlyUser) {
          //
        } else {
          if (
            productVal.sellerAuctionUserId === props.match.params.auctionUserId
          ) {
            //
          } else if (productVal.holdPreviousBidder !== undefined) {
            if (
              props.match.params.auctionUserId === productVal.holdPreviousBidder
            ) {
              ///
            } else {
              arr = [...arr, index];
            }
          } else if (productVal.previousBidderId !== undefined) {
            if (
              props.match.params.auctionUserId === productVal.previousBidderId
            ) {
              //
            } else {
              arr = [...arr, index];
            }
          } else if (
            productVal.auctionUserId === props.match.params.auctionUserId
          ) {
            //
          } else {
            if (productVal.auctionUserId === props.match.params.auctionUserId) {
              //
            } else {
              arr = [...arr, index];
            }
          }
        }
      }
    });

    if (isSelected) {
      setIsSelected(false);
      PubSub.publish("resetGridBoxIndex", []);
      arr = [];
      dispatch(resetTenderDiamondGridProductAllProductIndexes());
      dispatch(resetTenderDiamondAllProductSelectAll());
    } else {
      setIsSelected(true);
      dispatch(setTenderDiamondGridProductAllProductIndexes({ indexes: arr }));
      dispatch(setTenderDiamondAllProductSelectAll({ isSelected: true }));
    }
  };

  return (
    <AppLayout {...props}>
      {apiTimeout === true ? (
        <ApiTimeout t={t} {...props} />
      ) : (
        <Grid>
          {isLoading === true ? (
            <div className="loader">
              <LoadingSpinner />
            </div>
          ) : (
            <StyledLayoutGridMain
              container={true}
              className="StyledLayoutGridContainer"
            >
              {tabValue.allProducts === true ? (
                <>
                  <StyledBoxContent title="Click here for advance search">
                    <StyledDropDown
                      src="/images/assets/doubledown.png"
                      alt="d"
                      style={{
                        transform: isFiltersOpen
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                      }}
                      onClick={handleFilters}
                    />
                  </StyledBoxContent>
                  {isFiltersOpen === true && (
                    <div
                      style={{
                        padding: "20px",
                      }}
                    >
                      <TabLayout {...props} t={t} tabClick={tabItemClicks} />
                      {isShowParcelItem === false ? (
                        <ProductFilter
                          {...props}
                          t={t}
                          filteredAuctions={filteredAuction}
                          auctionId={props.match.params.auctionId}
                        />
                      ) : (
                        <ParcelItemFilter
                          {...props}
                          t={t}
                          filteredParcelAuctions={filteredAuction}
                          auctionId={props.match.params.auctionId}
                        />
                      )}
                    </div>
                  )}

                  <StyledHeaderContainer container={true} spacing={0}>
                    <StyledCoreDataGridContainer container={true} spacing={0}>
                      <StyledActionBarContainer
                        container={true}
                        spacing={0}
                        className="coreActionBarContainer"
                      >
                        <StyledContainer>
                          <BasicSearchBox
                            autoCompleteSearch={autoCompleteSearch}
                            textSearchListing={textSearchListing}
                            setTextSearchArray={setTextSearchArray}
                          />
                        </StyledContainer>
                        {notSmallDevices ? (
                          <>
                            {isGridView === true ? (
                              <StyledSelectAllButtonHeader
                                onClick={selectAllInGridView}
                              >
                                {t("common:newCommanTrans:selectAll")}
                              </StyledSelectAllButtonHeader>
                            ) : null}
                          </>
                        ) : (
                          <StyledSelectAllButtonHeader
                            onClick={selectAllInGridView}
                          >
                            {t("common:newCommanTrans:selectAll")}
                          </StyledSelectAllButtonHeader>
                        )}
                        {showBulkBidButton === true ? (
                          <StyledButtonHeader onClick={bulkBidPopupHandler}>
                            {t("common:preview:tendor:bulkBid")}
                          </StyledButtonHeader>
                        ) : (
                          <></>
                        )}
                        <StyledButtonHeader onClick={watchlist}>
                          My-page
                        </StyledButtonHeader>
                        <StyledButtonHeader
                          onClick={() =>
                            exportExcel(
                              auctionProducts,
                              props.match.params.auctionId
                            )
                          }
                        >
                          {t("common:preview:pagination:export")}
                        </StyledButtonHeader>
                        <TenderCommanPagination
                          setItemsPerPageHandler={setItemsPerPageHandler}
                          t={t}
                        />
                        {notSmallDevices ? (
                          <>
                            {isGridView === true ? (
                              <StyledButtonView onClick={Gridview}>
                                <Styledview src="/images/view/listView.png" />
                              </StyledButtonView>
                            ) : (
                              <StyledButtonView onClick={listGridview}>
                                <Styledview src="/images/view/gridview.jpeg" />
                              </StyledButtonView>
                            )}
                          </>
                        ) : null}
                      </StyledActionBarContainer>
                    </StyledCoreDataGridContainer>
                  </StyledHeaderContainer>
                </>
              ) : (
                <></>
              )}

              {/* main component without Accodion  */}
              <StyledLayoutGrid
                container={true}
                className="StyledLayoutGridContainer"
              >
                <Grid item={true} xs={12} style={{ paddingTop: "20px" }}>
                  <Grid
                    container={true}
                    spacing={0}
                    className="actionContainer"
                    style={{ padding: "0px 0px 0 8px" }}
                  >
                    <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                      <StyledTabLayout container spacing={0}>
                        <StyledContent item xs={12}>
                          <TenderTabLayout
                            {...props}
                            t={t}
                            tabClick={tabItemClick}
                          />
                        </StyledContent>
                      </StyledTabLayout>
                    </Grid>
                    <Grid item xs={12} sm={12} md={5} lg={4} xl={3}>
                      <StyledName>
                        <StyledContent>
                          <EllipsisText
                            text={auctionName !== undefined ? auctionName : ""}
                            length={28}
                            tail={"..."}
                          />
                        </StyledContent>
                      </StyledName>
                    </Grid>
                    <Grid item xs={12} sm={12} md={7} lg={4} xl={3}>
                      {seconds > 0 && (
                        <StyledTimeGridContainer container={true} spacing={0}>
                          {timeLeftLableColor ? (
                            <StyledTimer style={{ color: "red" }}>
                              <span>
                                {t("common:preview:tendor:timeLeft")}{" "}
                              </span>
                              <Countdown
                                date={Date.now() + seconds}
                                className="countdownText"
                                renderer={renderer}
                                zeroPadTime={2}
                              />
                            </StyledTimer>
                          ) : (
                            <StyledTimer>
                              <span>
                                {t("common:preview:tendor:timeLeft")}{" "}
                              </span>
                              <Countdown
                                date={Date.now() + seconds}
                                className="countdownText"
                                renderer={renderer}
                                zeroPadTime={2}
                              />
                            </StyledTimer>
                          )}
                        </StyledTimeGridContainer>
                      )}
                    </Grid>
                  </Grid>
                </Grid>

                {tabValue.allProducts === true ? (
                  <>
                    {auctionProducts.length > 0 ? (
                      <>
                        {isTopElementHide ? (
                          <StyledHeaderContainer container={true} spacing={0}>
                            <StyledCoreDataGridContainer
                              container={true}
                              spacing={0}
                            >
                              <StyledActionBarContainer
                                container={true}
                                spacing={0}
                                className="coreActionBarContainer"
                              >
                                {showBulkBidButton === true ? (
                                  <StyledButtonHeader
                                    onClick={bulkBidPopupHandler}
                                  >
                                    {t("common:preview:tendor:bulkBid")}
                                  </StyledButtonHeader>
                                ) : (
                                  <></>
                                )}
                                <StyledButtonHeader onClick={watchlist}>
                                  {t("common:menu:watchlist")}
                                </StyledButtonHeader>
                                <StyledButtonHeader
                                  onClick={() =>
                                    exportExcel(
                                      auctionProducts,
                                      props.match.params.auctionId
                                    )
                                  }
                                >
                                  {t("common:preview:pagination:export")}
                                </StyledButtonHeader>
                                <TenderCommanPagination
                                  setItemsPerPageHandler={
                                    setItemsPerPageHandler
                                  }
                                  t={t}
                                />
                                {isGridView === true ? (
                                  <StyledButtonView onClick={Gridview}>
                                    <Styledview src="/images/view/listView.png" />
                                  </StyledButtonView>
                                ) : (
                                  <StyledButtonView onClick={listGridview}>
                                    <Styledview src="/images/view/gridview.jpeg" />
                                  </StyledButtonView>
                                )}
                              </StyledActionBarContainer>
                            </StyledCoreDataGridContainer>
                          </StyledHeaderContainer>
                        ) : null}

                        {isGridView === false && notSmallDevices && (
                          <MuiThemeProvider theme={getMuiTheme()}>
                            {isDataTableRefresh ? (
                              <MUIDataTable
                                title={""}
                                data={auctionProducts}
                                columns={columns}
                                options={options}
                              />
                            ) : (
                              <MUIDataTable
                                title={""}
                                data={auctionProducts}
                                columns={columns}
                                options={options}
                              />
                            )}
                          </MuiThemeProvider>
                        )}

                        {isGridView === true
                          ? notSmallDevices && (
                              <>
                                <CoreDataGridOfTenderNew
                                  t={t}
                                  data={auctionProducts}
                                  totalElements={totalElement}
                                  itemPerPage={itemPerPage}
                                  value={getUpdatedProducts}
                                  noProductFound={handleMyBids}
                                  itemsPerPageUseRef={selectItemPerPageValue}
                                >
                                  {auctionProducts.length > 0 ? (
                                    <TenderListOfProduct
                                      {...props}
                                      watchlist={addToWatchList}
                                      setShowBidPopupBidModal={getBoxIndex}
                                      isCategoryPageType={isCategoryPageType}
                                      auctionName={
                                        props.match.params.auctionName
                                      }
                                      auctionDate={date[0]}
                                      t={t}
                                      isAuctionPage={isAuctionPage}
                                      unWatchlist={removeFromWatchlist}
                                      auctionUserId={
                                        props.match.params.auctionUserId
                                      }
                                      sortingValue={filterSort}
                                      boxColor={boxColor}
                                      myForProductAllProduct={
                                        myLatestBidForProduct
                                      }
                                      bulkBidIndexHandler={
                                        onGridSelectionChange
                                      }
                                      renderAutomaticBidPopupInMobile={
                                        renderAutomaticBidPopupInMobile
                                      }
                                      propsUserId={
                                        props.match.params.auctionUserId
                                      }
                                      renderReadOnlyUserToast={
                                        renderReadOnlyUserToast
                                      }
                                      rightClickEvent={rightClickEvent}
                                    />
                                  ) : (
                                    <Grid container={true} spacing={0}>
                                      <StyledTextWrapper item xs={12}>
                                        {t("common:preview:noProductFound")}
                                      </StyledTextWrapper>
                                    </Grid>
                                  )}
                                </CoreDataGridOfTenderNew>
                              </>
                            )
                          : null}

                        {notSmallDevices || (
                          <>
                            <CoreDataGridOfTenderNew
                              t={t}
                              data={auctionProducts}
                              totalElements={totalElement}
                              itemPerPage={itemPerPage}
                              value={getUpdatedProducts}
                              noProductFound={handleMyBids}
                              itemsPerPageUseRef={selectItemPerPageValue}
                            >
                              {auctionProducts.length > 0 ? (
                                <TenderListOfProduct
                                  {...props}
                                  watchlist={addToWatchList}
                                  setShowBidPopupBidModal={getBoxIndex}
                                  isCategoryPageType={isCategoryPageType}
                                  auctionName={props.match.params.auctionName}
                                  auctionDate={date[0]}
                                  t={t}
                                  boxColor={boxColor}
                                  isAuctionPage={isAuctionPage}
                                  unWatchlist={removeFromWatchlist}
                                  auctionUserId={
                                    props.match.params.auctionUserId
                                  }
                                  propsUserId={props.match.params.auctionUserId}
                                  sortingValue={filterSort}
                                  bulkBidIndexHandler={onGridSelectionChange}
                                  myForProductAllProduct={myLatestBidForProduct}
                                  renderAutomaticBidPopupInMobile={
                                    renderAutomaticBidPopupInMobile
                                  }
                                  renderReadOnlyUserToast={
                                    renderReadOnlyUserToast
                                  }
                                  rightClickEvent={rightClickEvent}
                                />
                              ) : (
                                <Grid container={true} spacing={0}>
                                  <StyledTextWrapper item xs={12}>
                                    {t("common:preview:noProductFound")}
                                  </StyledTextWrapper>
                                </Grid>
                              )}
                            </CoreDataGridOfTenderNew>
                          </>
                        )}
                      </>
                    ) : (
                      <Grid container={true} spacing={0}>
                        {notSmallDevices ? (
                          <MuiThemeProvider theme={getMuiTheme()}>
                            <MUIDataTable
                              title={""}
                              data={auctionProducts}
                              columns={columns}
                              options={options}
                            />
                          </MuiThemeProvider>
                        ) : (
                          <StyledTextWrapper item xs={12}>
                            {t("common:preview:noProductFound")}
                          </StyledTextWrapper>
                        )}
                      </Grid>
                    )}
                  </>
                ) : (
                  <TendorMybids {...props} />
                )}

                <Menu
                  keepMounted
                  open={mouseState.mouseY !== null}
                  onClose={handleClose}
                  anchorReference="anchorPosition"
                  anchorPosition={
                    mouseState.mouseY !== null && mouseState.mouseX !== null
                      ? { top: mouseState.mouseY, left: mouseState.mouseX }
                      : undefined
                  }
                >
                  <MenuItem
                    onClick={() =>
                      openDetailsView(
                        props.match.params.auctionId,
                        currentProductId,
                        props.match.params.auctionDate
                      )
                    }
                  >
                    Details
                  </MenuItem>
                </Menu>

                {openToast && (
                  <Alert
                    showAlertMessage={showAlertMessage}
                    alertType={alertType}
                  />
                )}
                {onAction && (
                  <div className="loading">
                    <LoadingSpinner />
                  </div>
                )}
                {userBlock && (
                  <StyledModal open={userBlock}>
                    <BlockUserModal t={t} {...props} closeModal={closeModal} />
                  </StyledModal>
                )}

                {openEndedModal && (
                  <StyledModal
                    open={openEndedModal}
                    onClose={TenderauctionEndedModal}
                  >
                    <ViewEndedModal
                      t={t}
                      {...props}
                      closeModal={TenderauctionEndedModal}
                    />
                  </StyledModal>
                )}
                {openTenderExtended && (
                  <StyledModal
                    open={openTenderExtended}
                    onClose={TenderTimeExtended}
                  >
                    <ViewTenderExtendedModal
                      t={t}
                      {...props}
                      closeModal={TenderTimeExtended}
                    />
                  </StyledModal>
                )}
                {showTenderSlider === true && (
                  <StyledModal open={showTenderSlider} onClose={closebidPopup}>
                    <TenderSlider
                      t={t}
                      {...props}
                      items={auctionProducts}
                      currentIndex={details}
                      sec={seconds}
                      timeRender={renderer}
                      PopupClose={closebidPopup}
                      handleBtnValue={handleBtnValue}
                      isFirstButtonDisables={false}
                      auctionDate={date[0]}
                      totalElements={totalElement}
                      endCount={endCount}
                      auctionUserId={props.match.params.auctionUserId}
                      length={length}
                      watchedFunction={addToWatchList}
                      unwatched={removeFromWatchlist}
                      boxColor={boxColor}
                    />
                  </StyledModal>
                )}

                {/* Single bidding Pop up */}
                {singleBiddingPopup && (
                  <StyledModal
                    open={singleBiddingPopup}
                    onClose={closebidPopup}
                  >
                    <TenderSlider
                      t={t}
                      {...props}
                      items={redirectProduct}
                      currentIndex={details}
                      sec={seconds}
                      timeRender={renderer}
                      PopupClose={closebidPopup}
                      handleBtnValue={handleBtnValue}
                      isFirstButtonDisables={false}
                      auctionDate={date[0]}
                      totalElements={redirectProduct.length}
                      endCount={endCount}
                      auctionUserId={props.match.params.auctionUserId}
                      length={length}
                      watchedFunction={addToWatchList}
                      unwatched={removeFromWatchlist}
                      boxColor={boxColor}
                    />
                  </StyledModal>
                )}

                {showBulkBidPopup === true && (
                  <StyledModal open={showBulkBidPopup} onClose={closebidPopup}>
                    <BulkBidPopup
                      {...props}
                      items={auctionProducts}
                      popupClose={closebidPopup}
                      handleBtnValue={bulkBidHandler}
                      auctionUserId={props.match.params.auctionUserId}
                      length={length}
                      productIndexs={indexsForBulkBidItems}
                      auctionDate={date[0]}
                      myLatestBidForProducts={myLatestBidForProduct}
                    />
                  </StyledModal>
                )}
                {openReadOnlyUserToast === true && (
                  <AlertReadOnlyUser
                    isReadOnlyUser={isReadOnlyUser}
                    isSeller={isAuctionUserId}
                  />
                )}
              </StyledLayoutGrid>
            </StyledLayoutGridMain>
          )}
        </Grid>
      )}
    </AppLayout>
  );
};

export default TendorAuctionView;
